/**
 * StatusBadge - Displays organization status with appropriate styling
 */
const STATUS_STYLES = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  trialing: "bg-blue-50 text-blue-700 border-blue-200",
  incomplete: "bg-amber-50 text-amber-700 border-amber-200",
  past_due: "bg-red-50 text-red-700 border-red-200",
  canceled: "bg-neutral-100 text-neutral-500 border-neutral-200",
};

export default function StatusBadge({ status }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 text-xs font-medium rounded-full border ${STATUS_STYLES[status] || STATUS_STYLES.incomplete}`}
      data-testid="org-status-badge"
    >
      {status}
    </span>
  );
}
